import {
  useEffect,
} from 'react';
import {
  useSelector,
} from 'react-redux';
import {
  OrganizationDTO,
} from 'artifacts/dtos';
import {
  RootState,
} from 'store/store';
import {
  setDefaultTimeZoneId,
} from 'utils/dayjs';

type NullableOrganizationDTO = OrganizationDTO | null;

export function useOrgTimeZone() {
  const timeZoneId = useSelector(
    (state: RootState) => (state.organization as NullableOrganizationDTO)?.timeZoneId,
  );

  useEffect(() => {
    setDefaultTimeZoneId(timeZoneId);
  }, [timeZoneId]);
}
